export default __webpack_public_path__ + "static/media/poster.f3633c8f.jpg";